<div class="scheduled-pickup-wrapper">
  <form (ngSubmit)="onSubmit()" [formGroup]="scheduledPickupForm">
    <app-modal-frame
      [headerText]="CONSTS.SCHEDULED_PICKUP_HEADER"
      (emitExit)="clickExit()"
    >
      <div class="content">
        <!-- Scheduling -->
        <ion-row class="scheduling">
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" class="section-header">
                {{ CONSTS.SCHEDULING_SUBHEADER }}
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="3" class="checkbox-container-col">
                <app-form-checkbox
                  [label]="CONSTS.ON_DEMAND_PICKUP"
                  [formControlName]="CONTROLS.ON_DEMAND_PICKUP"
                  [isDisabled]="true"
                ></app-form-checkbox>
              </ion-col>

              <!-- Days Assigned -->
              <ion-col size="9" class="days-assigned-wrapper">
                {{ CONSTS.DATE_ASSIGNED }}
                <span class="required-field"> * </span>
                <app-days-assigned
                  [data]="
                    scheduledPickupForm.get(CONTROLS.DAYS_ASSIGNED)?.value
                  "
                  (updateAvailabilityEvent)="daysAssignedUpdated($event)"
                ></app-days-assigned>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <!-- Pickup Request Number -->
              <ion-col size="3">
                <label [for]="CONTROLS.PICKUP_REQUEST_NUMBER">
                  {{ CONSTS.PICKUP_REQUEST_NUMBER }}
                </label>
                <ion-input
                  [attr.name]="CONTROLS.PICKUP_REQUEST_NUMBER"
                  class="pickup-row"
                  [formControlName]="CONTROLS.PICKUP_REQUEST_NUMBER"
                ></ion-input>
              </ion-col>

              <!-- Pickup Point -->
              <ion-col size="3">
                <label [for]="CONTROLS.PICKUP_POINT">
                  {{ CONSTS.PICKUP_POINT }}
                </label>
                <ion-input
                  class="pickup-row"
                  [attr.name]="CONTROLS.PICKUP_POINT"
                  [formControlName]="CONTROLS.PICKUP_POINT"
                ></ion-input>
              </ion-col>

              <!-- Route-->
              <ion-col size="2">
                <label [for]="CONTROLS.ROUTE">{{ CONSTS.ROUTE }}</label>
                <ng-select
                  class="custom-select"
                  appearance="outline"
                  labelForId="route"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="data.routes"
                  [formControlName]="CONTROLS.ROUTE"
                >
                </ng-select>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <!-- Start Date -->
              <ion-col size="3">
                <label [for]="CONTROLS.START_DATE">
                  {{ CONSTS.START_DATE }}
                </label>
                <app-form-date-picker
                  [placeholder]="CONSTS.DATE_PLACEHOLDER"
                  [formControlName]="CONTROLS.START_DATE"
                  [minDate]="startMinDate"
                  [maxDate]="startMaxDate"
                ></app-form-date-picker>
              </ion-col>

              <!-- End Date -->
              <ion-col size="3">
                <label [for]="CONTROLS.END_DATE">{{ CONSTS.END_DATE }} </label>
                <app-form-date-picker
                  [placeholder]="CONSTS.DATE_PLACEHOLDER"
                  [formControlName]="CONTROLS.END_DATE"
                  [minDate]="minDate"
                  [maxDate]="endMaxDate"
                ></app-form-date-picker>
              </ion-col>

              <!-- Ready Time-->
              <ion-col size="2">
                <label [for]="CONTROLS.READY_TIME">
                  {{ CONSTS.READY_TIME }}
                </label>
                <app-form-time-picker
                  [placeholderText]="CONSTS.TIME_PLACEHOLDER"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.READY_TIME"
                  [required]="false"
                  (inputChangedEvent)="dataChanged()"
                ></app-form-time-picker>
              </ion-col>

              <!-- Commit Time-->
              <ion-col size="2">
                <label [for]="CONTROLS.COMMIT_TIME">
                  {{ CONSTS.COMMIT_TIME }}
                </label>
                <app-form-time-picker
                  [placeholderText]="CONSTS.TIME_PLACEHOLDER"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.COMMIT_TIME"
                  [required]="false"
                  (inputChangedEvent)="dataChanged()"
                ></app-form-time-picker>
              </ion-col>

              <!-- Closing Time-->
              <ion-col size="2">
                <label [for]="CONTROLS.CLOSING_TIME">
                  {{ CONSTS.CLOSING_TIME }}
                </label>
                <app-form-time-picker
                  [placeholderText]="CONSTS.TIME_PLACEHOLDER"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.CLOSING_TIME"
                  [required]="false"
                  (inputChangedEvent)="dataChanged()"
                ></app-form-time-picker>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <!-- Interrupt Date -->
              <ion-col size="3">
                <label [for]="CONTROLS.INTERRUPT_DATE">
                  {{ CONSTS.INTERRUPT_DATE }}
                </label>
                <app-form-date-picker
                  [placeholder]="CONSTS.DATE_PLACEHOLDER"
                  [formControlName]="CONTROLS.INTERRUPT_DATE"
                  [minDate]="minDate"
                  [maxDate]="scheduledMaxDate"
                ></app-form-date-picker>
              </ion-col>

              <!-- Restart Date -->
              <ion-col size="3">
                <label [for]="CONTROLS.RESTART_DATE">
                  {{ CONSTS.RESTART_DATE }}
                </label>
                <app-form-date-picker
                  [placeholder]="CONSTS.DATE_PLACEHOLDER"
                  [formControlName]="CONTROLS.RESTART_DATE"
                  [minDate]="minDate"
                  [maxDate]="scheduledMaxDate"
                ></app-form-date-picker>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <!---------------->

        <!-- Customer Information -->
        <ion-row class="customer-information">
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" class="section-header">
                {{ CONSTS.CUSTOMER_SUBHEADER }}
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- Shipper Number -->
              <ion-col size="1.5">
                <app-form-text-field
                  [labelText]="CONSTS.SHIPPER_NUMBER"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.SHIPPER_NUMBER"
                  [maxLength]="6"
                  [minLength]="6"
                  [biggerText]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Customer Name -->
              <ion-col size="3.5">
                <app-form-text-field
                  [labelText]="CONSTS.CUSTOMER_NAME"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.CUSTOMER_NAME"
                  [maxLength]="50"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Contact Name -->
              <ion-col size="3.5">
                <app-form-text-field
                  [labelText]="CONSTS.CONTACT_NAME"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.CONTACT_NAME"
                  [hasRequiredSign]="false"
                  [maxLength]="22"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Contact Number -->
              <ion-col size="3.5">
                <app-form-text-field
                  [labelText]="CONSTS.CONTACT_NUMBER"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.CONTACT_NUMBER"
                  [hasRequiredSign]="false"
                  [maxLength]="25"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- Street Address -->
              <ion-col size="2">
                <app-form-text-field
                  [labelText]="CONSTS.STREET_ADDRESS"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.STREET_ADDRESS"
                  [hasRequiredSign]="false"
                  [maxLength]="11"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Prefix -->
              <ion-col size="1.5">
                <app-form-text-field
                  [labelText]="CONSTS.PREFIX"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.PREFIX"
                  [hasRequiredSign]="false"
                  [maxLength]="2"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Street Name -->
              <ion-col size="3.5">
                <app-form-text-field
                  [labelText]="CONSTS.STREET_NAME"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.STREET_NAME"
                  [maxLength]="50"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Suffix -->
              <ion-col size="1.5">
                <app-form-text-field
                  [labelText]="CONSTS.SUFFIX"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.SUFFIX"
                  [hasRequiredSign]="false"
                  [maxLength]="2"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Suite -->
              <ion-col size="1.5">
                <app-form-text-field
                  [labelText]="CONSTS.SUITE"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.SUITE"
                  [hasRequiredSign]="false"
                  [maxLength]="8"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Floor -->
              <ion-col size="2">
                <app-form-text-field
                  [labelText]="CONSTS.FLOOR"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.FLOOR"
                  [hasRequiredSign]="false"
                  [maxLength]="3"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- City -->
              <ion-col size="3">
                <app-form-text-field
                  [labelText]="CONSTS.CITY"
                  [form]="scheduledPickupForm"
                  [regexType]="REGEX_ALPHA"
                  [control]="CONTROLS.CITY"
                  [hasRequiredSign]="false"
                  [maxLength]="50"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Province -->
              <ion-col size="1.5">
                <app-form-text-field
                  [labelText]="CONSTS.PROVINCE"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.PROVINCE"
                  [maxLength]="2"
                  [minLength]="2"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Postal Code -->
              <ion-col size="2.5">
                <app-form-text-field
                  [labelText]="CONSTS.POSTAL_CODE"
                  [maxLength]="8"
                  [form]="scheduledPickupForm"
                  [control]="CONTROLS.POSTAL_CODE"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
                @if (
                  scheduledPickupForm.get("postalCode")?.dirty &&
                  scheduledPickupForm.get("postalCode")?.errors?.[
                    "nonCanadianPostal"
                  ]
                ) {
                  <div class="required-field">
                    {{ CONSTS.CANADIAN_POSTAL_ERROR }}
                  </div>
                }
              </ion-col>

              <!-- Latitude -->
              <ion-col size="2.5">
                <app-form-text-field
                  [labelText]="CONSTS.LATITUDE"
                  [form]="scheduledPickupForm"
                  [regexType]="REGEX_LATLONG"
                  [control]="CONTROLS.LATITUDE"
                  [hasRequiredSign]="false"
                  [readonly]="true"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>

              <!-- Longitude -->
              <ion-col size="2.5">
                <app-form-text-field
                  [labelText]="CONSTS.LONGITUDE"
                  [form]="scheduledPickupForm"
                  [regexType]="REGEX_LATLONG"
                  [control]="CONTROLS.LONGITUDE"
                  [hasRequiredSign]="false"
                  [readonly]="true"
                  [biggerText]="true"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <!---------------->

        <!-- Notes -->
        <ion-row class="notes">
          <ion-col size="12">
            <ion-row>
              <ion-col size="12" class="section-header">
                {{ CONSTS.NOTES }}
              </ion-col>
            </ion-row>

            <ion-row>
              <!-- SSC Description -->
              <ion-col size="5" class="text-area">
                <label [for]="CONTROLS.SSC_DESCRIPTION">
                  {{ CONSTS.SSC_DESCRIPTION }}
                </label>
                <textarea
                  class="input-area"
                  rows="4"
                  type="text"
                  [formControlName]="CONTROLS.SSC_DESCRIPTION"
                ></textarea>
              </ion-col>

              <!-- Additional Information  -->
              <ion-col size="7" class="text-area">
                <label [for]="CONTROLS.ADDITIONAL_INFORMATION">
                  {{ CONSTS.ADDITIONAL_INFORMATION }}
                </label>
                <textarea
                  class="input-area"
                  rows="4"
                  type="text"
                  [placeholder]="CONSTS.ADDITIONAL_INFORMATION_PLACEHOLDER"
                  [formControlName]="CONTROLS.ADDITIONAL_INFORMATION"
                ></textarea>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <!---------------->
      </div>

      <div class="footer">
        <!-- Save button -->
        <ion-button
          class="button"
          fill="solid"
          type="submit"
          [ngClass]="
            scheduledPickupForm.dirty && scheduledPickupForm.valid
              ? 'enabled'
              : 'disabled'
          "
          [disabled]="!scheduledPickupForm.dirty || !scheduledPickupForm.valid"
        >
          <ion-icon
            slot="start"
            class="check-icon"
            [src]="SRC.CHECK_WHITE"
            alt="save"
          ></ion-icon>
          {{ CONSTS.SAVE }}
        </ion-button>
      </div>
    </app-modal-frame>
  </form>

  <!-- Validate Button -->
  @if (data.isIdoEnabled) {
    <div class="validation-section">
      <ion-row class="validate-row">
        <div class="validation-text">
          <ion-col>
            @if (validationCode === "-5") {
              <span class="validate-error-text">{{
                CONSTS.VALIDATION_FAILED_NULL_SITE_ID
              }}</span>
            }
            @if (validationCode === "-4") {
              <span class="validate-error-text">{{
                CONSTS.VALIDATION_FAILED_REQUEST_ID
              }}</span>
            }
            @if (validationCode === "-3") {
              <span class="validate-error-text">{{
                CONSTS.VALIDATION_FAILED_INPUT_ADDRESS
              }}</span>
            }
            @if (validationCode === "-2") {
              <span class="validate-error-text">{{
                CONSTS.VALIDATION_FAILED_AAA_UNAVAILABLE
              }}</span>
            }
            @if (validationCode === "-1") {
              <span class="validate-error-text">{{
                CONSTS.VALIDATION_FAILED_SOURCE_INVALID
              }}</span>
            }
            @if (validationCode === "0" && !validatedLngNr && !validatedLatNr) {
              <span class="validate-error-text">{{
                CONSTS.VALIDATION_FAILED_NO_LATLONG
              }}</span>
            }
            @if (validationCode === "0" && validatedLngNr && validatedLatNr) {
              <span class="validate-success-text">{{
                CONSTS.VALIDATION_SUCCEEDED
              }}</span>
            }
          </ion-col>
        </div>
        <ion-col>
          <ion-button
            class="button validate-button"
            fill="outline"
            [ngClass]="
              scheduledPickupForm.dirty && scheduledPickupForm.valid
                ? 'enabled'
                : 'disabled'
            "
            [disabled]="
              !scheduledPickupForm.dirty || !scheduledPickupForm.valid
            "
            (click)="validate()"
          >
            {{ CONSTS.VALIDATE }}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  }
</div>
